import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Auth, onAuthStateChanged} from "@angular/fire/auth";

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  private _auth =  inject(Auth)

  isAuthenticatedUser(): Observable<boolean> {
    return new Observable(observer => {
      onAuthStateChanged(this._auth, (user) => {
        if (!user || user.isAnonymous || !user.emailVerified) {
          observer.next(false)
        } else {
          observer.next(true)
        }
      })
    })
  }
}
